import { render, staticRenderFns } from "./RegistrationStepOne.vue?vue&type=template&id=8fa373fa&scoped=true&"
import script from "./RegistrationStepOne.vue?vue&type=script&lang=js&"
export * from "./RegistrationStepOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa373fa",
  null
  
)

export default component.exports